import { supabase } from "./supabase";

export const IMPERSONATION_KEY = "adr-admin-workspace";

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const session = supabase ? (await supabase.auth.getSession()).data.session : null;
  const impersonation = typeof sessionStorage !== "undefined" ? sessionStorage.getItem(IMPERSONATION_KEY) : null;
  const response = await fetch(path, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(session?.access_token ? { Authorization: `Bearer ${session.access_token}` } : {}),
      ...(impersonation && !path.startsWith("/api/admin") ? { "X-Admin-Impersonate": impersonation } : {}),
      ...(init.headers || {}),
    },
  });
  const payload = await response.json().catch(() => ({})) as T & { message?: string };
  if (!response.ok) throw new Error(payload.message || "The request could not be completed.");
  return payload;
}
